import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { LayoutProvider } from "./contexts/LayoutContext";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    // Global handler for Shopify OAuth callback
    // Detects if user was redirected from backend OAuth flow and navigates to integrations page
    const searchParams = new URLSearchParams(window.location.search);
    const shopifyStatus = searchParams.get("shopify"); // "success" or "error"
    const shopifyShop = searchParams.get("shop");
    const shopifyError = searchParams.get("error");

    // Handle backend OAuth callback redirect (path: /integrations?shopify=success&shop=...)
    if (window.location.pathname === '/integrations' && shopifyStatus) {
      console.log("Shopify OAuth callback detected, redirecting to integrations page");

      // Build query string for hash route
      const params = new URLSearchParams();
      params.set("shopify", shopifyStatus);
      if (shopifyShop) params.set("shop", shopifyShop);
      if (shopifyError) params.set("error", shopifyError);

      // Use window.location.replace to clear the original /integrations path and query params
      // This prevents duplicate query params (one before # and one after #)
      const newUrl = `${window.location.origin}/#/e-commerce/integrations?${params.toString()}`;
      window.location.replace(newUrl);
      return;
    }

    // Handle Universal Ads OAuth callback redirect (path: /integrations?universal_ads=success)
    const uaStatus = searchParams.get("universal_ads");
    if (window.location.pathname === '/integrations' && uaStatus) {
      console.log("Universal Ads OAuth callback detected, redirecting to integrations page");

      const params = new URLSearchParams();
      params.set("universal_ads", uaStatus);
      const uaError = searchParams.get("error");
      if (uaError) params.set("error", uaError);

      const newUrl = `${window.location.origin}/#/facebook/integrations?${params.toString()}`;
      window.location.replace(newUrl);
      return;
    }

    // Legacy Shopify callback handler (direct from Shopify with hmac/session)
    const shopifyHmac = searchParams.get("hmac");
    const shopifySession = searchParams.get("session");

    if (shopifyHmac && shopifyShop && shopifySession) {
      const currentPath = window.location.hash || window.location.pathname;

      if (!currentPath.includes("/e-commerce/integrations")) {
        console.log("Legacy Shopify OAuth callback detected, redirecting to integrations page");

        // Redirect to integrations page with callback params (using hash routing)
        const params = `hmac=${shopifyHmac}&shop=${shopifyShop}&session=${shopifySession}&host=${searchParams.get("host") || ""}&timestamp=${searchParams.get("timestamp") || ""}`;
        navigate(`/e-commerce/integrations?${params}`);
      }
    }
  }, [navigate]);

  return (
    <LayoutProvider>
      <AppRoutes />
    </LayoutProvider>
  );
}

export default App;
// Test automated index.html update - Thu Oct 16 23:43:27 IST 2025
